import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext({});
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser]         = useState(null);
  const [pharmacy, setPharmacy] = useState(null);
  const [role, setRole]         = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, async (u) => {
      if (u) {
        const token = await u.getIdTokenResult(true);
        const r   = token.claims.role       || null;
        const pid = token.claims.pharmacyId || null;
        setUser(u);
        setRole(r);
        if (pid) {
          const snap = await getDoc(doc(db, 'pharmacies', pid));
          if (snap.exists()) {
            setPharmacy({ id: snap.id, ...snap.data() });
          } else {
            console.warn('AuthContext: pharmacyId claim', pid, 'not found in Firestore');
            setPharmacy(null);
          }
        } else {
          setPharmacy(null);
        }
      } else {
        setUser(null);
        setPharmacy(null);
        setRole(null);
      }
      setLoading(false);
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, pharmacy, role, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
